var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import authentication from "@irati/auth";
import { TextButton } from "@irati/ui/src/Button";
import { CommentsIcon, ReactionsIcon, AddRewardIcon } from "./";
import { ReactionList } from "../Reactions";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n\n  ", " {\n    margin-right: 6px;\n  }\n"], ["\n  display: flex;\n\n  ", " {\n    margin-right: 6px;\n  }\n"])), TextButton);
var Activity = /** @class */ (function (_super) {
    __extends(Activity, _super);
    function Activity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Activity.prototype.render = function () {
        var _a = this.props, item = _a.item, type = _a.type, onClickComment = _a.onClickComment, togglePickerModal = _a.togglePickerModal, feedItemId = _a.feedItemId;
        var areReactionsEnabled = !!authentication.apps("recognition.recognition.reactions");
        return (React.createElement(Container, null,
            React.createElement("div", null,
                React.createElement(AddRewardIcon, { item: item, type: type }),
                React.createElement(CommentsIcon, { id: feedItemId, item: item, onClick: onClickComment }),
                areReactionsEnabled && React.createElement(ReactionList, { item: item }),
                areReactionsEnabled && React.createElement(ReactionsIcon, { onClick: togglePickerModal }))));
    };
    Activity.defaultProps = {
        onClickComment: function () { },
        togglePickerModal: function () { },
        feedItemId: "feedItemId"
    };
    return Activity;
}(Component));
export default Activity;
var templateObject_1;
